export default __webpack_public_path__ + "img/f2de1b88cded20983b4e37565afe0ff6.svg";